import React from 'react';
import { Select } from '@material-ui/core';
import { UNSELECTED_RIDING_DATE_STRING } from './useForm';

interface Props {
  value: luxon.DateTime,
  onChange: (e: React.ChangeEvent<{
    name?: string | undefined;
    value: unknown;
  }>) => void,
  selectTimeList: string[],
  isUnselectedRidingDate: boolean
}

/** タクシー・ハイヤー予約画面の時刻のセレクトボックスのコンポーネント。 */
export const SelectHourAndMinutesPulldown: React.FC<Props> = (props: Props) => {
  /** 未選択状態なら未選択の値を選択 */
  const currentValue = props.isUnselectedRidingDate? UNSELECTED_RIDING_DATE_STRING: props.value.toFormat('HHmm');

  const setValue = (v: string) => {
    /** 未選択状態であればそのまま返す */
    if(v === UNSELECTED_RIDING_DATE_STRING) {
      return UNSELECTED_RIDING_DATE_STRING;
    }
    return `${v.slice(0, 2)} 時 ${v.slice(-2)} 分`;
  }

  return (
    <Select native value={currentValue} onChange={props.onChange}>
      {
        props.selectTimeList.map((time) => {
          return <option value={time} key={`hours_${time}`}>{setValue(time)}</option>
        })
      }
    </Select>
  );
}

export default SelectHourAndMinutesPulldown;
